import { getData, postData } from '@/utils/http';
import config from '@/config';
export default {
  namespaced: true,
  state: {
    detailId: '',
    status: '',
    tableLoading: true,
    addLoading: false,
    activeItem: {},
    tableList: [],
    tableData: [],
    type: '',
    pageIndex: 1,
    total: 0,
    regionData: [],
    unitList: [],
    personList: [],
    isVerify: false,
    statusList: {
      0: '拒绝接单',
      1: '待审核',
      2: '审核通过',
      3: '审核拒绝',
      4: '等待接单',
      5: '运输中',
      6: '等待付款',
      96: '上架',
      97: '下架',
      98: '取消',
      99: '完成',
    },
  },
  mutations: {
    CHANGE_ACTIVE_ITEM(state, item) {
      item.records.forEach((e) => {
        if (e.imgInfos && e.imgInfos.length > 0) {
          e.imgInfoList = e.imgInfos.map((ds) => {
            return ds.url;
          });
        }
      });

      state.activeItem = item;
    },
    CHANGE_DETAIL_ID(state, value) {
      state.detailId = value;
    },
    CHANGE_TABLE_LOADING(state, tableLoading) {
      state.tableLoading = tableLoading;
    },
    CHANGE_ADD_LOADING(state, addLoading) {
      state.addLoading = addLoading;
    },
    CHANGE_TABLE_DATA(state, data) {
      state.tableList = data.rows;
      state.total = data.total;
    },
    CHANGE_SEARCH_COLL(state, changeData) {
      if (
        changeData['changeKey'] == 'orgId' &&
        typeof changeData['data'] != 'object'
      ) {
        state[changeData['changeKey']] = [changeData['data']];
      } else {
        state[changeData['changeKey']] = changeData['data'];
      }
    },
    CHANGE_TABLE_INDEX(state, value) {
      state.pageIndex = value;
    },
    CHANGE_IS_REVIEW(state, value) {
      state.isVerify = value;
    },
  },
  actions: {
    //获取列表
    getList({ commit, state }) {
      let province = '';
      let city = '';
      if (state.regionData.length > 0) {
        province = state.regionData[0];
        city = state.regionData[1];
        if (
          state.regionData[0] == '北京市' ||
          state.regionData[0] == '天津市'
        ) {
          city = state.regionData[0];
        }
      }
      const queryParams = config.jsonToQueryParams({
        page: state.pageIndex,
        size: config.pageSize,
        status: state.status == 10 ? '' : state.status,
        province,
        city,
      });

      return new Promise((resolve) => {
        getData(`platform/order/page?${queryParams}`).then((res) => {
          if (res.state == 1) {
            commit('CHANGE_TABLE_DATA', res.data);
            resolve({
              state: 1,
              msg: '操作成功',
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },
    getUnitList({}, data) {
      return new Promise((resolve) => {
        getData('platform/order/transport/unit/list', data).then((res) => {
          if (res.state == 1) {
            resolve({
              state: 1,
              msg: '操作成功',
              data: res.data,
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },
    getPersonList({}, data) {
      return new Promise((resolve) => {
        getData('platform/order/transport/person/list', data).then((res) => {
          if (res.state == 1) {
            resolve({
              state: 1,
              msg: '操作成功',
              data: res.data,
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },
    getDetail({ commit, state }) {
      console.log(state.detailId);
      return new Promise((resolve) => {
        getData(`platform/order/get/${state.detailId}`).then((res) => {
          if (res.state == 1) {
            commit('CHANGE_ACTIVE_ITEM', res.data);
            resolve({
              state: 1,
              msg: '操作成功',
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },
    handleExamine({}, data) {
      return new Promise((resolve) => {
        postData('platform/order/examine', data).then((res) => {
          if (res.state == 1) {
            resolve({
              state: 1,
              msg: '操作成功',
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },
    handleOrderCancel({}, data) {
      return new Promise((resolve) => {
        postData('platform/order/cancel', data).then((res) => {
          if (res.state == 1) {
            resolve({
              state: 1,
              msg: '操作成功',
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },
    //写入查询条件
    setSearchData({ commit }, changeData) {
      commit('CHANGE_SEARCH_COLL', changeData);
    },
    //修改分页
    setPageIndex({ commit }, value) {
      commit('CHANGE_TABLE_INDEX', value);
    },
    //修改添加loading
    changeAddLoading({ commit }, value) {
      commit('CHANGE_ADD_LOADING', value);
    },
    //修改添加loading
    changeListLoading({ commit }, value) {
      commit('CHANGE_TABLE_LOADING', value);
    },
  },
};
